module.exports = __webpack_public_path__ + "img/Perks-45.99da88dc.png";